import type { Brand } from '@/types/brand.types';

import { ApiResponse } from '@/types/services';
import { BrandStatusOption } from '@/types/common.types';

import { baseApi } from './base-api';
import { buildQueryParams } from './helpers';
import { apiService, downloadBlob } from './api';

export const brandsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getBrandsStatusOptions: builder.query<BrandStatusOption[], void>({
      query: () => ({ url: 'brands/status-options' }),
      transformResponse: (response: ApiResponse<BrandStatusOption[]>): BrandStatusOption[] => {
        return response.data;
      }
    }),
    getBrandsList: builder.query<Brand[], void>({
      query: () => ({ url: 'brands' }),
      providesTags: ['BrandsList'],
      transformResponse: (response: ApiResponse<Brand[]>): Brand[] => {
        return response.data;
      }
    }),
    createBrand: builder.mutation<Brand, Brand>({
      query: (brand: Brand) => ({
        url: `/brands`,
        method: 'POST',
        body: brand
      }),
      transformResponse: (response: ApiResponse<Brand>): Brand => {
        return response.data;
      },
      invalidatesTags: ['BrandsList']
    }),
    updateBrands: builder.mutation<Brand[], Brand[]>({
      query: (brands: Brand[]) => ({
        url: 'brands/bulk',
        method: 'PUT',
        body: brands
      }),
      transformResponse: (response: ApiResponse<Brand[]>): Brand[] => {
        return response.data;
      },
      invalidatesTags: ['BrandsList']
    }),
    exportBrandsToExcel: builder.mutation<boolean, Record<string, any> | void>({
      async queryFn(filters = {}) {
        try {
          const queryString = buildQueryParams(filters as any);
          const { blob, filename } = await apiService.getBlob(`/brands/export${queryString ? `?${queryString}` : ''}`);
          downloadBlob(blob, filename);
          return { data: true };
        } catch (error) {
          return { error: error as any };
        }
      }
    })
  })
});
export const {
  useGetBrandsStatusOptionsQuery,
  useGetBrandsListQuery,
  useCreateBrandMutation,
  useUpdateBrandsMutation,
  useExportBrandsToExcelMutation
} = brandsApi;
